import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

import BillingHeaderNav from "../../components/BillingHeaderNav";

import CurrentPlan from "./CurrentPlan";
import { CreditsInfo } from "./CreditsInfo";
import TransactionsInvoicesTable from "./TransactionsInvoicesTable";

const PlansOverviewPage = () => {
  const { t } = useTranslation("plans", { keyPrefix: "page.plansOverviewPage" });

  return (
    <Box sx={styles.root} component="main">
      <BillingHeaderNav />
      <Typography variant="h3" sx={styles.headerTitle}>
        {t("currentPlan")}
      </Typography>
      <CurrentPlan />
      <CreditsInfo />

      <TransactionsInvoicesTable />
    </Box>
  );
};

export default PlansOverviewPage;

const styles = {
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    width: "100%",
  },
  headerTitle: {
    color: "var(--black-100, #1C1C1C)",
    fontFamily: "Montserrat",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "30px",
  },
};
